<template>
  <div id="login">
    <div class="box hide-scrollbars">
      <div class="info">
        <img class="logo main" src="/img/logo_new.png" />
        <div class="title" style="text-align: center">
          {{ "login.volunteers" | i18n }}
        </div>
      </div>

      <div class="language">
        <div class="lang" @click="changeLang('ca')">CA</div>
        <div class="lang" @click="changeLang('es')">ES</div>
      </div>

      <div class="form" v-show="!show_remember && !show_login">
        <button type="button" v-on:click="show_login = true">
          {{ $t("login.login") }}
        </button>
        <button type="button" v-on:click="newVolunteer()">
          {{ $t("login.sign_up") }}
        </button>
      </div>

      <div class="form" v-show="!show_remember && show_login">
        <div class="message error" v-if="error_message">
          {{ error_message }}
        </div>
        <input
          type="text"
          name="username"
          v-model="input.username"
          :placeholder="$t('login.dni')"
          v-on:keyup.enter="login()"
          v-on:focus="onfocus = true"
        />
        <input
          type="password"
          name="password"
          v-model="input.password"
          :placeholder="$t('login.password')"
          v-on:keyup.enter="login()"
          v-on:focus="onfocus = true"
        />
        <button type="button" v-on:click="login()">
          {{ $t("login.login") }}
        </button>

        <div
          @click="(show_remember = !show_remember), (show_login = false)"
          class="remember"
        >
          {{ $t("login.rememberme") }}
        </div>
        <div
          @click="(show_remember = false), (show_login = false)"
          class="remember"
        >
          {{ $t("login.back") }}
        </div>
      </div>

      <div class="form" v-show="show_remember && !show_login">
        <div v-if="email_send" class="message success">
          {{ $t("login.email_send") }}
        </div>
        <div class="message error" v-if="error_message_remember">
          {{ error_message_remember }}
        </div>
        <input
          type="text"
          name="username"
          v-model="input.remember"
          :placeholder="$t('login.dni')"
          v-on:keyup.enter="remember()"
          v-on:focus="onfocus = true"
        />
        <button type="button" v-on:click="remember()">
          {{ $t("login.rememberme") }}
        </button>
        <div @click="show_remember = !show_remember" class="remember">
          {{ $t("login.back") }}
        </div>
      </div>
    </div>

    <div
      @click="goIntowin"
      class="tech-partner"
      :class="{ onfocus: onfocus }"
    ></div>
  </div>
</template>

<script>
//import router from '@/router';
import { Api } from "@/core/api.js";
const api = new Api();

import i18n from "@/i18n";

export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: "",
        remember: ""
      },
      error_message: false,
      error_message_remember: false,
      show_remember: false,
      show_login: false,
      onfocus: false,
      email_send: false
    };
  },
  methods: {
    login() {
      var validation = [];

      var username = this.input.username;
      var password = sha256(this.input.password);

      if (username.trim() == "" || username.trim().length <= 0)
        validation.push(false);
      if (password.trim() == "" || password.trim().length <= 0)
        validation.push(false);

      if (validation.indexOf(false) == -1) {
        var self = this;
        api
          .login({ username: username, password: password })
          .then(function(response) {
            if (response.status) {
              self.error_message = false;
              self.$store.commit(
                "events/setEventsActive",
                response.data.events
              );
              self.$store.commit("user/setAuthenticate", response.data);

              localStorage.setItem("token", response.data.token);

              if (typeof localStorage.redirect !== "undefined") {
                self.$router.push(localStorage.redirect);
                localStorage.removeItem("redirect");
              } else {
                self.$router.push("/");
              }
            } else {
              self.error_message = "Dades d'accés incorrectes";
            }
          });
      } else {
        this.error_message = "Dades d'accés incorrectes";
      }
    },

    newVolunteer() {
      this.lang = this.$route.params.lang;
      if (!["ca", "es"].includes(this.lang)) {
        this.lang = "ca";
      }
      this.$router.push("/newvolunteer/" + this.lang);
    },

    changeLang(lang) {
      this.$route.params.lang = lang;
      i18n.loadLanguageAsync(lang);
      this.$router.push("/login/" + lang);
    },

    remember() {
      var username = this.input.remember;
      if (username.trim() != "" && username.trim().length > 0) {
        var self = this;
        api
          .post("volunteer/remember", {
            username: username,
            lang: this.$route.params.lang
          })
          .then(function(response) {
            if (response.status) {
              self.error_message_remember = i18n.t("login.email_send");
              self.email_send = true;
              self.error_message_remember = false;
            } else {
              self.error_message_remember = i18n.t("errors.login");
            }
          });
      } else {
        this.error_message_remember = i18n.t("errors.user");
      }
    },

    created() {
      this.$store.commit("user/setAuthenticate", false);

      this.lang = this.$route.params.lang;

      if (!["ca", "es"].includes(this.lang)) {
        this.lang = "ca";
      }

      localStorage.setItem("language", this.lang);

      i18n.loadLanguageAsync(this.lang);

      switch (this.lang) {
        case "ca":
          // TODO FILES URLS
          break;
        case "es":
          // TODO FILES URLS
          break;
        case "en":
          // TODO FILES URLS
          break;
      }
    },

    goIntowin() {
      window.open("http://www.intowin.io", "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
#container {
  padding: 0 !important;
}

.language {
  position: absolute;
  top: 10px;
  right: 10px;

  .lang {
    padding: 0 10px;
    font-weight: bold;
    font-size: 20px;
    float: left;
    // font-family: AvantGarde-Bold;
    cursor: pointer;
    color: white;

    &:not(:first-child) {
      border-left: 1px solid white;
    }
  }
}

#login {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 25px;
  background: $dark-color;
  // background: linear-gradient(0deg, rgb(245, 245, 245), #FFF);
  // color: $secondary-color;
  overflow: auto;

  .box {
    max-width: 275px;
    width: 100%;
    height: auto;
    max-height: calc(100% - 40px);
    margin: 0 auto;
    overflow: auto;
    text-align: center;

    .message.error {
      background-color: #f73f2061;
      margin: 10px 0;
      border: 2px solid #e61515;
      border-radius: 5px;
      padding: 10px;
      color: #fff;
      font-weight: bold;
    }

    .title {
      color: white;
    }

    .info {
      text-align: center;

      .logo {
        display: inline-block;
        height: 150px;
        padding: 15px;

        &.main {
          height: 100px;
        }
      }

      .description {
        width: 100%;
        display: block;
        color: white;
        font-size: 16px;
        text-align: center;
      }
    }
    .form {
      margin-top: 50px;
    }

    input {
      width: 100%;
      padding: 15px;
      margin-bottom: 5px;
      border: 1px solid #444;
      outline: none;
      font-size: 11pt;
      border-radius: 3px;
      color: white;
      display: block;

      &::placeholder {
        color: white;
      }
    }

    button {
      width: calc(100%);
      padding: 12px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      border-radius: 3px;
      text-transform: uppercase;
      transition: all 0.5s;
      background-color: $secondary-color;
      color: #000;
      margin-top: 12px;
      font-weight: bold;

      &.secondary {
        background: none;
        text-transform: initial;
        color: #999;
        font-weight: lighter;

        &:hover {
          text-decoration: underline;
        }
      }

      &:hover {
        // background-color: white;
        // color: #fff;
      }
    }

    button + .mlanguage {
      width: calc(100% - 50px);
    }

    button + .mlanguage,
    .mlanguage {
      display: inline-block;
      margin-top: 12px;
      height: 40px;
    }
    .mlanguage {
      float: none;
    }

    .remember {
      font-size: 10pt;
      margin-top: 20px;
      color: $secondary-color;
      cursor: pointer;
      display: block;
      text-decoration: none;
      text-align: center;
      color: #999;
      text-decoration: underline;

      &:hover {
        text-decoration: underline;
      }
    }

    .success {
      border: 2px solid #087908;
      border-radius: 5px;
      background-color: #a0f8b6;
      color: #000;
      padding: 10px;
      font-size: 16px;
      text-align: center;
    }
  }

  .tech-partner {
    @include display-flex();
    @include align-items(center);
    @include justify-content(center);
    position: fixed;
    // position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 50px;
    @include background(
      $image: img("intowin_partner_v2.png"),
      $size: 250px,
      $position: center
    );
    cursor: pointer;
  }
}

@include media("<=desktop") {
  #login {
    overflow: hidden;
    margin-top: 50px;

    .box .info .logo {
      height: 100px;
      padding: 6px;
      width: auto;
    }
    .box .form {
      margin-top: 24px;
    }

    .tech-partner.onfocus {
      display: none;
    }
  }
}
</style>
<style lang="scss">
#login {
  .v-input {
    margin-bottom: 5px;
    .v-input__slot,
    .v-input__slot:hover {
      border: 1px solid #000;

      .v-select__selections {
        padding-top: 0;
        input::-webkit-input-placeholder {
          color: #000;
        }
      }
    }
  }
}
</style>
